import * as ko from "knockout";
import { extended_request } from "../request/extended_request_dto";
import { CustomObservables } from "CustomObservables";
import labels from "app/labels";
import { warranty_defective_part } from "entitiesE";
import { WARRANTY_TYPE } from "./warranty_type";

export class warranty_request extends extended_request {
  user_def4_check: KnockoutComputed<boolean>;
  proofOfPurchaseRequired: KnockoutObservable<boolean>;
  declare c_wty_claim_defective_part: KnockoutObservableArray<warranty_defective_part>;
  attachmentsRequired: KnockoutObservable<boolean>;
  model_id: KnockoutObservable<string>;
  ext_travel_distance: KnockoutObservable<number>;
  user_def18: KnockoutObservable<string>;
  user_def_dttm3: KnockoutObservable<Date>;
  formatteduser_def_dttm3: any;
  ext_return_order_no: KnockoutObservable<string>;
  ext_travel_zone: KnockoutObservable<string>;
  c_foc_request: KnockoutObservable<string>;
  c_foc_request_check: KnockoutObservable<boolean>;
  ext_original_toner: KnockoutObservable<string>;
  ext_technician: KnockoutObservable<string>;
  sparepartOneDevice: KnockoutObservable<string>;
  warranty_type: KnockoutComputed<WARRANTY_TYPE>;
  ext_rma_reject_reason: KnockoutObservable<string>;

  constructor(item?: any) {
    super(item);
    if (item) {
      this.c_wty_claim_defective_part = <KnockoutObservableArray<warranty_defective_part>>(
        this.loadRelation(item, warranty_defective_part, "c_wty_claim_defective_part", "array")
      );
    }

    this.proofOfPurchaseRequired = ko.observable(false);
    this.attachmentsRequired = ko.observable(true);
    this.counterColorRequired = ko.observable(false);
    this.model_id = ko.observable();
    this.user_def_dttm1.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_REPAIR_DATE_REQ"),
      },
    });
    this.user_def_dttm2.extend({
      required: {
        onlyIf: () => {
          return this.proofOfPurchaseRequired();
        },
        params: true,
        message: labels.descr("cc_P_END_PUR_DATE_REQ"),
      },
    });
    this.user_def2.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_SERIAL_ID_REQ"),
      },
    });
    this.user_def4_check = ko.pureComputed({
      read: () => {
        return this.user_def4() && this.user_def4() == "Y";
      },
      write: (value: boolean) => {
        this.user_def4(value ? "Y" : "N");
      },
    });

    this.user_def_num1.extend({
      required: {
        params: true,
        message: labels.descr("cc_P_VALUE_REQ"),
      },
      digit: { params: true, message: labels.descr("cc_P_ENTER_VALID_NUMBER") },
      min: {
        params: 1,
        message: labels.descrWithParams("cc_P_VALUE_MIN", [1]),
      },
      max: {
        params: 60000000,
        message: labels.descrWithParams("cc_P_VALUE_MAX", [60000000]),
      },
    });
    this.user_def_num2.extend({
      required: {
        onlyIf: () => {
          return this.counterColorRequired();
        },
        params: true,
        message: labels.descr("cc_P_VALUE_REQ"),
      },
      digit: { params: true, message: labels.descr("cc_P_ENTER_VALID_NUMBER") },
      min: {
        params: 1,
        message: labels.descrWithParams("cc_P_VALUE_MIN", [1]),
      },
      max: {
        params: 60000000,
        message: labels.descrWithParams("cc_P_VALUE_MAX", [60000000]),
      },
    });
    this.ext_travel_distance = ko.observable();
    this.user_def18 = ko.observable(item?.user_def18);
    this.user_def_dttm3 = ko.observable(this.formatJSONDate(item?.user_def_dttm3));
    this.formatteduser_def_dttm3 = CustomObservables.formattedDateObservable(this.user_def_dttm3);
    this.ext_return_order_no = ko.observable(item?.ext_return_order_no);
    this.ext_travel_zone = ko.observable(item?.ext_travel_zone);

    this.c_foc_request = ko.observable(item?.c_foc_request);
    this.c_foc_request_check = ko.pureComputed({
      read: () => {
        return this.c_foc_request() && this.c_foc_request() == "Y";
      },
      write: (value: boolean) => {
        this.c_foc_request(value ? "Y" : "N");
      },
    });

    this.ext_original_toner = ko.observable(item?.ext_original_toner);
    this.ext_technician = ko.observable(item?.ext_technician);
    this.sparepartOneDevice = ko.observable("N");
    this.ext_rma_reject_reason = ko.observable(item?.ext_rma_reject_reason);
    this.warranty_type = ko.computed(() => {
      const user_def_3 = this.user_def3() ?? null;
      const request_subtype = this.ext_portal_req_subtype() ?? null;

      if (user_def_3 === "SPAREPART") {
        return WARRANTY_TYPE.SPAREPART;
      }

      switch (request_subtype) {
        case "300":
        case "301": {
          return WARRANTY_TYPE.SPAREPART;
        }
        case "302": {
          return WARRANTY_TYPE.SPAREPART_WITH_DEVICE;
        }
        default: {
          return WARRANTY_TYPE.DEVICE;
        }
      }
    });

    this.rowColor = ko.pureComputed(() => {
      switch (this.user_def10()) {
        case "REJECTED_FI":
        case "OPEN": {
          return "#fcd4d4";
        }
        default: {
          return null;
        }
      }
    });
  }
}
